import { render, staticRenderFns } from "./FindingtheMVPofMSPs.vue?vue&type=template&id=b00d8448&scoped=true&"
import script from "./FindingtheMVPofMSPs.vue?vue&type=script&lang=js&"
export * from "./FindingtheMVPofMSPs.vue?vue&type=script&lang=js&"
import style0 from "./FindingtheMVPofMSPs.vue?vue&type=style&index=0&id=b00d8448&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b00d8448",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VContent } from 'vuetify/lib/components/VContent';
import { VImg } from 'vuetify/lib/components/VImg';
import { VMain } from 'vuetify/lib/components/VMain';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VContent,VImg,VMain,VRow})
